import InventoryImport from "./InventoryImport.presenter";
export default InventoryImport;
